<div class="title">
  <div class="title__title">{{ title | translate }}</div>
  <!-- <div class="title__label">
    <ng-content></ng-content>
  </div> -->
</div>
